export const PRICING_TABLE_ROW_TITLE_TEST_ID = {
  title: 'title',
  description: 'description',
};
